import defineComponent from 'flight';
import ItemsClickStorage from 'static/script/app/models/items-click-storage';

function WishListUI() {
    this._storage = new ItemsClickStorage();

    this.defaultAttrs({
        addToWishList: '[data-add-to-wish-list]',
        removeFromWishList: '[data-remove-from-wish-list]',
        itemId: null
    });

    this._add = function () {
        this.$node.addClass('wish-list-selector-selected');

        let payload = {
            itemId: this.attr.itemId
        };

        payload = this._addSearchIdToPayload(payload);

        this.trigger(document, 'ui:item:on-add-to-wish-list', payload);

        this.trigger(document, 'analytics:track-event', {
            category: 'View item',
            action: 'Add to wish list',
            label: 'Added item: ' + this.attr.itemId,
            userTriggered: true
        });

        let categoryId = this.$node.context.getAttribute('data-item-categoryid');
        this.trigger(document, 'nuggad:on-add-to-wish-list', {
            categoryId: categoryId
        });
    };

    this._remove = function () {
        this.$node.removeClass('wish-list-selector-selected');

        let payload = {
            itemId : this.attr.itemId
        };

        payload = this._addSearchIdToPayload(payload);

        this.trigger(document, 'ui:item:on-remove-from-wish-list', payload);

        this.trigger(document, 'analytics:track-event', {
            category: 'View item',
            action: 'Removed from wish list',
            label: 'Removed item: ' + this.attr.itemId,
            userTriggered: true
        });
    };

    this._addSearchIdToPayload = function (payload) {
        let searchId = this._storage.getSearchId(this.attr.itemId);

        if (searchId) {
            payload.s = searchId;
        }

        return payload;
    };

    this.after('initialize', function () {

        this.on('click', {
            addToWishList: this._add,
            removeFromWishList: this._remove
        });

    });
}

module.exports = defineComponent.component(WishListUI);


// WEBPACK FOOTER //
// ./src/EbaySweden.TouchWeb/static/script/app/ui/view-item/wish-list-ui.js